export async function downloadFile(url, filename) {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || inferFilename(url, blob.type);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } catch (e) {
    console.error('Download failed', e);
  }
}

function inferFilename(url, mime) {
  const urlExt = url.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase();
  const knownExts = ['mp4', 'webm', 'mov', 'png', 'jpg', 'jpeg', 'webp', 'gif'];
  let ext = knownExts.includes(urlExt) ? urlExt : null;
  if (!ext) {
    ext = mime?.includes('video') ? 'mp4'
      : mime?.includes('png') ? 'png'
      : mime?.includes('webp') ? 'webp'
      : mime?.includes('jpeg') || mime?.includes('jpg') ? 'jpg'
      : 'bin';
  }
  return `pornoclaw_${Date.now()}.${ext}`;
}
